/**
 * @props value: To show the progress on progress bar 
 * @props maxValue: Max percentage of progress bar
 * @props iconName: Icon name 
 */


import React from 'react'
import "./directcss/HorizontalProgressBar.scss"
import { VEC_ICON_NAME } from '../icons/constants';
import Icons from '../icons/Icons';

const HorizontalProgressBar = ({ value = 0, maxValue = 100, iconName = VEC_ICON_NAME.PROGRESS_ICON, showValue = false }) => {
    const progress = (value / maxValue) * 100;

    return (
        <div className='main-container'>

            {iconName && <Icons familyName='vec' iconName={iconName} />}
            <div className='progress-outter-container'>
                { showValue &&
                    <div className='progress-value'>
                        {progress}%
                    </div>
                }
                <div className="progress-bar-container">
                    <div className="progress-bar" style={{ width: `${progress}%` }}></div>
                </div>
            </div>
        </div>
    );
}

export default HorizontalProgressBar
